import { Tooltip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';
import { MessageStatus } from './message-status';

interface Props {
    status: MessageStatus;
    failureReason?: string | null;
}

/// Convenção do WhatsApp: relógio, um tique (Meta aceitou), dois (entregue), dois azuis (lido).
export const MessageStatusIcon = ({ status, failureReason }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    const size = { fontSize: 13 };

    if (status === MessageStatus.Failed) {
        return (
            <Tooltip title={failureReason || t('crmMessages.statusFalhou')}>
                <ErrorOutlineIcon sx={{ ...size, color: cc.eventDanger }} />
            </Tooltip>
        );
    }

    if (status === MessageStatus.Pending) {
        return (
            <Tooltip title={t('crmMessages.statusPendente')}>
                <ScheduleIcon sx={{ ...size, color: cc.textMuted }} />
            </Tooltip>
        );
    }

    if (status === MessageStatus.Read) {
        return (
            <Tooltip title={t('crmMessages.statusLida')}>
                <DoneAllIcon sx={{ ...size, color: cc.accent }} />
            </Tooltip>
        );
    }

    if (status === MessageStatus.Delivered) {
        return (
            <Tooltip title={t('crmMessages.statusEntregue')}>
                <DoneAllIcon sx={{ ...size, color: cc.textSecondary }} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={t('crmMessages.statusEnviada')}>
            <DoneIcon sx={{ ...size, color: cc.textSecondary }} />
        </Tooltip>
    );
};
